import React, { useEffect, useRef, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import { Form, Input, Loading, Button, Select } from "Components";
import { components } from "react-select";


import ForgotPwdLink from "../../common/ForgotPwdLink";
import ChatWithSupport from "../../common/ChatWithSupport";
import SocialMediaButtons from "./SocialMediaButtons";
import SocialMediaError from "./SocialMediaError";
import ModalConfigMediaUser from "./ModalConfigMediaUser";
import ModalMigrateUser from "./ModalMigrateUser";
import LoginLogo from "../../common/LoginLogo";

import { reset } from "./../redux/slice";
import {
  login,
  loginConfirmClose,
  validateUser,
  checkUserRequest
} from "../redux/slice";
import { set } from "lodash";

function FormLogin({ current_reseller, reseller_was_validated, callback }) {
  const { messages } = useIntl();
  const frmLogin = useRef();
  const usernameInputRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [listUsers, setListUsers] = useState([])
  const [confirmationCode, setConfirmationCode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showListUsers, setShowListUsers] = useState(false);
  const [useMultiAccount, setUseMultiAccount] = useState(false)

  const {
    loading,
    loadingSM,
    error,
    loginPage,
    cognitoValues,
    result,
    showConfirm,
    verifiedUsers,
    checkUser
  } = useSelector((state) => state.loginRedux);

  const urlImgLogo = current_reseller
    ? current_reseller?.loginCompanyLogo
    : "/assets/images/verticalLogo.png";

  const handleClose = () => {
    dispatch(loginConfirmClose());
    setConfirmationCode("");
    setShowPassword(false)
    setUseMultiAccount(false)
    setPassword("");
    setUsername("");
    setSelectedUser(null);
    setShowListUsers(false);
  };

  useEffect(() => {
    if (verifiedUsers) {

      let users = verifiedUsers?.users?.map((x) => {
        return {
          ...x,
          composeName: `${x.companyTitle} - ${x.isSubUser ? messages["login_user"] : messages["login_account"]}`,
          authId: `PX_${x.companyId}${x.isSubUser ? `_${x.id}` : ''}`
        }
      })
      setListUsers(users);
      if (users.length > 0)
        setSelectedUser(users[0]);
      setShowListUsers(true);
    }

  }, [verifiedUsers]);

  useEffect(() => {
    if (checkUser) {
      if (checkUser?.exists) {
        setUseMultiAccount(checkUser.multiAccount)
        setShowPassword(true)
      }
      dispatch(reset({ checkUser: null }))
    }

  }, [checkUser]);
  return (
    <>
      <Box
        style={{
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          width: "100%",
        }}
      >
        <div style={{ width: "500px" }} className="background-white-login">
          <Box className="form-login-container">
            {reseller_was_validated && <LoginLogo urlImgLogo={urlImgLogo} />}
            {error && <SocialMediaError error={error} showPassword={showPassword} />}
            {
              loadingSM ? (
                <div className="loading-area" style={{ minHeight: 200 }}>
                  <Loading />
                </div>
              ) : (
                <Form
                  ref={frmLogin}
                  onValidSubmit={() => {
                    // Get the current value directly from the Input component to handle fast typing
                    const currentUsername = usernameInputRef.current?.getValue() || username;
                    const trimmedUsername = currentUsername?.trim();

                    if (showListUsers) {
                      if (selectedUser)
                        dispatch(login({ username: selectedUser?.email, password, navigate, authId: selectedUser?.authId }));

                      return;
                    }

                    if (showPassword) {
                      callback(trimmedUsername, password, selectedUser?.authId)
                      //if has multi account show select to choose account and then login, if not login directly
                      if (useMultiAccount) {
                        dispatch(validateUser({ username: trimmedUsername, password }));
                      }
                      else
                        //if no multi account, login directly with the username, password and authId null because not needed
                        dispatch(login({ username: trimmedUsername, password, navigate }));
                    } else {
                      dispatch(checkUserRequest({ username: trimmedUsername }));
                    }
                  }}
                >
                  {
                    showListUsers && listUsers ?
                      <div>
                        <p style={{ fontSize: "16px", margin: "30px 0 0 0", fontWeight: "400", }} >
                          {showPassword ? messages["login_log_into_account"] : messages["login_email_or_username"]}
                          <span className="text-danger"> *</span>
                        </p>

                        <Select
                          type="text"
                          options={listUsers}
                          customOption={(props) => {
                            const { data, innerProps, innerRef } = props;
                            return (
                              <components.Option {...props}>
                                <div {...innerProps} ref={innerRef}>
                                  <div >
                                    {data.composeName}
                                  </div>
                                  <div style={{ color: 'gray' }}>
                                    ({data.email})
                                  </div>
                                </div>
                              </components.Option>
                            )
                          }}
                          onChange={(value) => {
                            setSelectedUser(value);
                          }}
                          isRequiered
                          requiredMessage={messages["required_field"]}
                          textField="composeName"
                          valueField="authId"
                          disabled={listUsers.length < 2 || loading}
                          value={selectedUser}
                        />
                      </div>
                      :
                      <div>
                        <div>
                          <p
                            style={{
                              fontSize: "16px",
                              margin: "30px 0 0 0",
                              fontWeight: "400",
                            }}
                          >
                            {showPassword ? messages["login_log_into_account"] : messages["login_email_or_username"]}
                            <span className="text-danger"> *</span>
                          </p>
                          <Input
                            ref={usernameInputRef}
                            id="login"
                            name="login"
                            type="text"
                            autoComplete="on"
                            placeholder={messages["login_email_or_username"]}
                            value={username}
                            onChange={(text) => {
                              setUsername(text);
                            }}
                            required
                            requiredMessage={messages["required_field"]}
                            autoFocus
                            //notRequiderdShow
                            disabled={showPassword}
                          />
                        </div>
                        <div style={{ paddingTop: 10 }}>
                          {
                            showPassword && (
                              <Input
                                id="txtPassword"
                                type="password"
                                label={""}
                                placeholder={messages["login_password"]}
                                value={password}
                                onChange={(text) => {
                                  setPassword(text);
                                }}
                                required
                                autoFocus
                                requiredMessage={messages["required_field"]}
                                notRequiderdShow
                              />
                            )
                          }
                        </div>
                      </div>
                  }
                  <div style={{ paddingTop: 10 }}>
                    {
                      loading ? (
                        <div className="loading-area">
                          <Loading />
                        </div>
                      ) : (
                        <>
                          <Grid container spacing={showPassword ? 1 : 0}>
                            {showPassword && (
                              <Grid item sm={6}>
                                <Button
                                  tabIndex={2}
                                  id="btnCancelLogin"
                                  onClick={() => {
                                    dispatch(
                                      reset({
                                        cognitoValues: null,
                                        error: null,
                                        showConfirm: false,
                                        token: null,
                                        showPassword: false,
                                        loginPage: loginPage,
                                        verifiedUsers: null,
                                        isSocialMediaLogin: false,
                                      })
                                    );

                                    setConfirmationCode("");
                                    setShowPassword(false);
                                    setUseMultiAccount(false);
                                    setPassword("");
                                    setUsername("");
                                    setSelectedUser(null);
                                    setShowListUsers(false);
                                  }}
                                  className="btn btn-gray btn-block margin-top-10"
                                >
                                  <FormattedMessage id="login_back" />
                                </Button>
                              </Grid>
                            )}

                            <Grid
                              style={{ width: "100%" }}
                              item
                              sm={showPassword ? 6 : 12}
                            >
                              <Button
                                id="btnSignin"
                                className="btn btn-blue btn-block margin-top-10"
                                tabIndex={1}
                                disabled={loading}
                                onClick={(e) => {
                                  e.preventDefault();
                                  frmLogin.current.submit();
                                }}
                              >
                                <FormattedMessage
                                  id={
                                    showPassword ? `login_next` : `login_continue`
                                  }
                                />
                              </Button>
                            </Grid>
                          </Grid>
                          <Box style={{ margin: "25px 0 0 0" }}>
                            <ForgotPwdLink current_reseller={current_reseller} />
                          </Box>
                          {((!current_reseller && reseller_was_validated) || (reseller_was_validated && current_reseller.code === "zonar")) && (
                            <>
                              <Box style={{ margin: "5px 0 0 0" }}>
                                <ChatWithSupport />
                              </Box>
                              {!showPassword && <SocialMediaButtons />}
                            </>
                          )}
                        </>
                      )
                    }
                  </div>
                </Form>
              )}
          </Box>
        </div>
      </Box>
      <ModalConfigMediaUser />
      <ModalMigrateUser
        handleClose={handleClose}
        error={error}
        username={username}
        confirmationCode={confirmationCode}
        setConfirmationCode={setConfirmationCode}
        loading={loading}
        cognitoValues={cognitoValues}
        result={result}
        showConfirm={showConfirm}
      />
    </>
  );
}

export default FormLogin;
